import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";

const BrandDrawer = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const defaultData = {
    name: "",
  };

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      if (isEdit) {
        await onSubmit({ ...data, ...values });
      } else {
        await onSubmit(values);
      }
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to submit the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Brand" : "Add Brand"}
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={defaultData}
      >
        <Form.Item
          label="Brand Name"
          name="name"
          rules={[{ required: true, message: "Please enter the brand name." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            block
            htmlType="submit"
            loading={isLoading}
          >
            {isEdit ? "Update Brand" : "Add Brand"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default BrandDrawer;
